import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { getRestaurantDetailRequest, updateRestaurantProfileRequest } from "../../redux/action";
import { PageLoader } from "../../component/common/Loader";
import "./RestaurantSetting.css";

const RestaurantSetting = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState("");
  const { restaurant, loading, error } = useSelector((state) => state.admin);

  console.log("restaurant", restaurant)
  useEffect(() => {
    dispatch(getRestaurantDetailRequest());
  }, [dispatch]);

  useEffect(() => {
    if (restaurant) {
      setProfile({
        restaurantOrBranchName: restaurant.restaurantOrBranchName || "",
        contactNumber: restaurant.client?.contactNumber || "",
        mail: restaurant.client?.mail || "",
        address: restaurant.address || "",
        city: restaurant.city?.cityName || "",
        state: restaurant.state?.stateName || "",
        pincode: restaurant.pincode || "",
        loginPageImageUrl: restaurant.loginPageImageURL || "",
        showLoginPageImage: restaurant.showLoginPageImage || ""
      });
    }
  }, [restaurant]);



  const [editing, setEditing] = useState({});

  const handleEdit = (field) => {
    setEditing({ ...editing, [field]: true });
  };

  const handleSave = (field) => {
    setEditing({ ...editing, [field]: false });

    // Build payload with updated value
    const updatedPayload = {
      ...restaurant, // existing data from Redux
      [field]: profile[field], // update restaurant fields
    };

    console.log("Saving field:", field, "with value:", profile[field]);

    if (field === 'contactNumber' || field === 'mail') {
      const updateClient = { ...restaurant.client, [field]: profile[field] };

      dispatch(updateRestaurantProfileRequest(updateClient));
      console.log("updateClient:", updateClient);
    } else {
      // Dispatch action with full payload
      dispatch(updateRestaurantProfileRequest(updatedPayload));
      console.log("updatedPayload:", updatedPayload);
    }
  };


  const [profile, setProfile] = useState({
    restaurantOrBranchName: "ARK",
    contactNumber: "",
    mail: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    loginPageImageUrl:""
  });

  const handleChange = (field, value) => { setProfile({ ...profile, [field]: value }); };

  if (loading)
    return <div className="restaurant-settings-page"><PageLoader label="Loading restaurant settings..." /></div>;
  if (error)
    return <div className="restaurant-settings-page"><div className="restaurant-settings-state restaurant-settings-error">Error: {error}</div></div>;

const renderRow = (label, field, type = "text") => {
  // Special case for checkbox that saves immediately
  if (type === "checkbox") {
    return (
      <div className="tax-row">
        <span className="tax-label">{label}</span>
        <div className="tax-input-wrapper">
          <input
            type="checkbox"
            checked={!!profile[field]}
            onChange={(e) => {
              const checked = e.target.checked;
              setProfile({ ...profile, [field]: checked });
              const updatedPayload = {
                ...restaurant,
                [field]: checked,
              };
              dispatch(updateRestaurantProfileRequest(updatedPayload));
              console.log("Auto-saved checkbox:", field, checked);
            }}
          />
        </div>
      </div>
    );
  }

  // Default behavior for other fields (with Edit/Save buttons)
  return (
    <div className="tax-row">
      <span className="tax-label">{label}</span>
      <div className="tax-input-wrapper">
        {type === "textarea" ? (
          <textarea
            placeholder="Type your full address here..."
            rows={4}
            cols={25}
            style={{ padding: "10px", marginTop: "5px" }}
            disabled={!editing[field]}
            value={profile[field] || ""}
            onChange={(e) => handleChange(field, e.target.value)}
          />
        ) : type === "file" ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
            <input
            ref={fileInputRef}
            type="file"
            style={{ display: "none" }}
            disabled={!editing[field]}
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                setSelectedFileName(file.name);
               // const fileUrl = URL.createObjectURL(file);
               // setProfile({ ...profile, [field]: fileUrl });

                const reader = new FileReader();
                reader.onloadend = () => {
                // 🚀 This guarantees a pure Base64 DataURL string format instead of a broken local blob link!
               // setThumbnailUrl(reader.result); 
                 setProfile({ ...profile, [field]: reader.result });
            };
            reader.readAsDataURL(file);
              }
              
            }}
          />
          <button
            type="button"
            className="edit-btn"
            disabled={!editing[field]}
            onClick={() => fileInputRef.current?.click()}
          >
            {t("Choose File")}
          </button>
          <span>{selectedFileName || t("No file chosen")}</span>
          </div>
        
          
        ) : (
          <input
            type={type}
            placeholder={label}
            disabled={!editing[field]}
            value={profile[field] || ""}
            onChange={(e) => handleChange(field, e.target.value)}
          />
        )}
      </div>

      {!editing[field] ? (
        <button className="edit-btn" onClick={() => handleEdit(field)}>Edit</button>
      ) : (
        <button className="save-btn" onClick={() => handleSave(field)}>Save</button>
      )}
    </div>
  );
};





  return (
      <div className="restaurant-settings-page">
        <div className="restaurant-settings-title">
          <h1>Restaurant profile</h1>
          <p>Manage your restaurant contact details and menu login image.</p>
        </div>

        <div className="tax-card restaurant-settings-card">
        {renderRow("Name", "restaurantOrBranchName")}
        {renderRow("Contact Number", "contactNumber")}
        {renderRow("Email", "mail")}
        {renderRow("Address", "address", "textarea")}
        {renderRow("Pincode", "pincode")}
        {renderRow("Upload menu login page image", "loginPageImageUrl", "file")}
        {profile.loginPageImageUrl && (
         <img src={profile.loginPageImageUrl} alt="Login Page" className="restaurant-login-preview" />
         )}
        {renderRow("Display image in menu login page", "showLoginPageImage", "checkbox")}

        </div>
      </div>
  );
};

export default RestaurantSetting;
